import React from 'react';
import classNames from 'classnames';
import { roundedOptions, shadowOptions } from '../../editor/Toolbar/options';

export const getImageStyle = (props) => {
	const { margin, width, height } = props;
	return {
		margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
		width: `${width}px`,
		height: `${height}px`,
	};
};

export const getImageClasses = (props) => classNames({ [shadowOptions[props.shadow]]: !!props.shadow }, { [roundedOptions[props.rounded]]: !!props.rounded });
export default function Image({ src, altText, className, ...props }) {
	if (!src) {
		return null;
	}

	return (
		<img
			alt={altText || 'image'}
			src={src}
			style={getImageStyle(props)}
			className={classNames(getImageClasses(props))}
		/>
	);
}
